"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribeFuturesLevel1 = exports.unsubscribeAllFuturesLevel1 = exports.subscribeToFuturesLevel1 = exports.receiveLevel1SummaryData = exports.getFuturesLevel1Data = exports.getAllFuturesLevel1Data = exports.addFuturesLevel1 = exports.UNSUBSCRIBE_FUTURES_LEVEL1 = exports.SUBSCRIBE_FUTURES_LEVEL1 = exports.FUTURES_SUMMARY_LEVEL1_LOADED = exports.FUTURES_LEVEL1_LOADED = void 0;
var _FuturesLevel1SubscriptionService = _interopRequireDefault(require("../services/FuturesLevel1SubscriptionService"));
var _get = _interopRequireDefault(require("lodash/get"));
var _apiActions = require("../../actions/apiActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var FUTURES_SUMMARY_LEVEL1_LOADED = exports.FUTURES_SUMMARY_LEVEL1_LOADED = 'FUTURES_SUMMARY_LEVEL1_LOADED';
var FUTURES_LEVEL1_LOADED = exports.FUTURES_LEVEL1_LOADED = 'FUTURES_LEVEL1_LOADED';
var SUBSCRIBE_FUTURES_LEVEL1 = exports.SUBSCRIBE_FUTURES_LEVEL1 = 'SUBSCRIBE_FUTURES_LEVEL1';
var UNSUBSCRIBE_FUTURES_LEVEL1 = exports.UNSUBSCRIBE_FUTURES_LEVEL1 = 'UNSUBSCRIBE_FUTURES_LEVEL1';
var getAllFuturesLevel1Data = exports.getAllFuturesLevel1Data = function getAllFuturesLevel1Data() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetFuturesLevel1Summary', {
              OMSId: (0, _get["default"])(getState(), 'user.userInfo.OMSId', 1)
            })).then(function (res) {
              return dispatch(receiveLevel1SummaryData(res));
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

/**
 * 1) Tell server to subscribe to futures level1 data for passed `instrumentId`
 * 2) Get first portion of data
 */
var getFuturesLevel1Data = exports.getFuturesLevel1Data = function getFuturesLevel1Data(instrumentId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return _FuturesLevel1SubscriptionService["default"].initSubscription(instrumentId).then(function (updates) {
              return dispatch(addFuturesLevel1(instrumentId, updates));
            })["catch"](function () {});
          case 1:
            return _context2.a(2, _context2.v);
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var subscribeToFuturesLevel1 = exports.subscribeToFuturesLevel1 = function subscribeToFuturesLevel1() {
  return function (dispatch) {
    dispatch({
      type: SUBSCRIBE_FUTURES_LEVEL1
    });
    _FuturesLevel1SubscriptionService["default"].subscribe(function (updates) {
      dispatch(addFuturesLevel1(updates.InstrumentId, updates));
    });
  };
};
var unsubscribeFuturesLevel1 = exports.unsubscribeFuturesLevel1 = function unsubscribeFuturesLevel1(instrumentId) {
  return function (dispatch) {
    dispatch({
      type: UNSUBSCRIBE_FUTURES_LEVEL1
    });
    _FuturesLevel1SubscriptionService["default"].stopOne(instrumentId);
  };
};
var unsubscribeAllFuturesLevel1 = exports.unsubscribeAllFuturesLevel1 = function unsubscribeAllFuturesLevel1() {
  return function () {
    _FuturesLevel1SubscriptionService["default"].stopAll();
  };
};
var addFuturesLevel1 = exports.addFuturesLevel1 = function addFuturesLevel1(instrumentId, level1Data) {
  return {
    type: FUTURES_LEVEL1_LOADED,
    payload: {
      instrumentId: instrumentId,
      level1Data: level1Data
    }
  };
};
var receiveLevel1SummaryData = exports.receiveLevel1SummaryData = function receiveLevel1SummaryData(level1Data) {
  return {
    type: FUTURES_SUMMARY_LEVEL1_LOADED,
    payload: level1Data
  };
};